/**
 * Custom error class for API client errors.
 * Use this instead of generic Error for API-related failures.
 */
export class ApiClientError extends Error {
  constructor(
    public readonly statusCode: number,
    public readonly code: string,
    message: string
  ) {
    super(message);
    this.name = 'ApiClientError';
  }

  static fromResponse(response: Response, context: string): ApiClientError {
    return new ApiClientError(
      response.status,
      'API_ERROR',
      `${context}: ${response.statusText}`
    );
  }

  static async fromResponseWithBody(response: Response, context: string): Promise<ApiClientError> {
    const result = {
      message: response.statusText,
      code: 'API_ERROR' 
    };

    try {
      const body: unknown = await response.json();
      const parsed = body as Record<string, unknown>;
      if (typeof parsed.message === 'string') {
        result.message = parsed.message;
      }
      if (typeof parsed.code === 'string') {
        result.code = parsed.code;
      }
    } catch {
      // If we can't parse the body, use the status text
    }

    return new ApiClientError(response.status, result.code, `${context}: ${result.message}`);
  }
}

/**
 * Helper to build URL with optional query string
 */
export function buildUrl(base: string, path: string, params?: URLSearchParams): string {
  const queryString = params?.toString();
  if (queryString) {
    return `${base}${path}?${queryString}`;
  }
  return `${base}${path}`;
}
